import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-payment-result',
  templateUrl: './payment-result.component.html',
  styleUrls: ['./payment-result.component.css']
})
export class PaymentResultComponent implements OnInit {
  private baseUrl: string;
  private http: HttpClient;
  private route: ActivatedRoute;
  private sanitizer: DomSanitizer;

  model: PaymentRequestResultViewModel;
  trackingCode: string;
  clusterTrackingCode: PaymentRequestResultViewModel;

  constructor(http: HttpClient, route: ActivatedRoute, sanitizer: DomSanitizer, @Inject('BASE_URL') baseUrl: string) {
    this.baseUrl = baseUrl;
    this.http = http;
    this.route = route;
    this.sanitizer = sanitizer;
  }

  ngOnInit(): void {
    this.model = null; //{} as PaymentRequestResultViewModel;

    this.trackingCode = this.route.snapshot.paramMap.get('tc');

    this.http.get<ServiceResult<PaymentRequestResultViewModel>>(
      `${environment.ServicesUrl}${environment.PayResultEndpoint}`
      .replace('{trackingCode}',this.trackingCode))
      .subscribe(result => {
      if (result.hasError) {
        alert(result.message);
        return;
      }

      result.result.res = result.result.isSucceed ? 'success' : 'fail';
      this.model = result.result;

    }, error => {
      console.error(error)
    });

    // this.http.get<ServiceResult<PaymentRequestResultViewModel>>(
    //   `${environment.ServicesUrl}${environment.TrackingCodeEndpoint}/${this.trackingCode}`)
    //   .subscribe(result => {
    //   if (result.hasError) {
    //     alert(result.message);
    //     return;
    //   }


    // }, error => {
    //   console.error(error)
    // });
  }

  getSafeUrl() {
    return this.sanitizer.bypassSecurityTrustUrl(this.model.responseTo);
  }
  
}

interface PaymentVerifyResultViewModel {
  isPaid: boolean;
  trackingNumber: number;
  amount: number;
  gatewayName: string;
  gatewayAccountName: string;
  transactionCode: string;
  message: string;
}

interface ServiceResult<T> {
  hasError: boolean;
  message: string;
  referenceId: string;
  result: T;
  responseTo: string;
}

interface PaymentRequestResultViewModel {
  isSucceed: boolean;
  message: string;
  res: string;
  transporter: GatewayTransporter;
  responseTo: string;
  trackingCode: string;
}

interface GatewayTransporter {
  type: TransportType;
  url: string;
  form: KeyValuePair[];
}

interface KeyValuePair {
  key: any;
  value: any;
}

enum TransportType {
  Post,
  Redirect
}
